import { usePopUpMessage } from '@hb/react'
import { ErrorWithMessage, PracticeContract, WithId } from '@hb/shared'
import { useCallback } from 'react'
import { deletePracticeContract } from '../../../backend/functions/practiceContracts'
import { DeleteButton } from '../../Buttons/DeleteButton'

export const DeletePracticeContractButton = ({
  contract,
}: {
  contract: WithId<PracticeContract>
}) => {
  const { showError, showSuccess } = usePopUpMessage()
  const handleDelete = useCallback(async () => {
    try {
      await deletePracticeContract({
        practiceId: contract.practiceId,
        practiceContractId: contract.id,
      })
      showSuccess('Practice contract deleted')
    } catch (error: any) {
      showError('Error deleting practice contract', (error as ErrorWithMessage).message)
    }
  }, [contract, showError, showSuccess])
  if (contract.signedOn) return null
  return (
    <DeleteButton
      borderRadius="full"
      size="sm"
      variant="ghost"
      onDelete={handleDelete}
      itemName="practice contract"
    />
  )
}
